<template>
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16 2.66666C13.3629 2.66666 10.785 3.44864 8.59239 4.91373C6.39974 6.37881 4.69077 8.4612 3.6816 10.8975C2.67243 13.3339 2.40839 16.0148 2.92286 18.6012C3.43733 21.1876 4.70721 23.5634 6.57191 25.4281C8.43661 27.2928 10.8124 28.5627 13.3988 29.0771C15.9852 29.5916 18.6661 29.3276 21.1024 28.3184C23.5388 27.3092 25.6212 25.6002 27.0863 23.4076C28.5513 21.2149 29.3333 18.6371 29.3333 16C29.3333 14.249 28.9885 12.5152 28.3184 10.8975C27.6483 9.27987 26.6662 7.81001 25.4281 6.5719C24.19 5.33379 22.7201 4.35166 21.1024 3.6816C19.4848 3.01153 17.751 2.66666 16 2.66666ZM16 26.6667C13.8903 26.6667 11.828 26.0411 10.0739 24.869C8.31979 23.6969 6.95262 22.031 6.14528 20.0819C5.33795 18.1329 5.12671 15.9882 5.53829 13.919C5.94986 11.8499 6.96576 9.94928 8.45752 8.45752C9.94928 6.96576 11.8499 5.94986 13.919 5.53828C15.9882 5.1267 18.1329 5.33794 20.082 6.14528C22.031 6.95261 23.6969 8.31978 24.869 10.0739C26.0411 11.828 26.6667 13.8903 26.6667 16C26.6667 18.829 25.5429 21.5421 23.5425 23.5425C21.5421 25.5429 18.829 26.6667 16 26.6667Z"
			fill="#FFD210"
		/>
		<rect x="12" y="11" width="2" height="10" rx="1" fill="#FFD210" />
		<rect x="18" y="11" width="2" height="10" rx="1" fill="#FFD210" />
	</svg>
</template>
<script>
export default {
	name: 'IconPause',
}
</script>
